import { Box, Text } from '@dixa/lib-shared-habla';
import { ComponentProps } from 'react';
import { useFormState, useWatch } from 'react-hook-form';

import { HookFormText } from 'components/hookForm';

import { FormValues } from '../../../../customFormEditPage.types';
import { makeCharLeftWarning } from '../../utils/makeCharLeftWarning';

export function CharLimitedTextInput(
  props: ComponentProps<typeof HookFormText<FormValues>> & {
    maxLength: number;
    name: Exclude<keyof FormValues, 'formFields'>;
  },
): JSX.Element {
  const watchedValue = useWatch<FormValues>({ name: props.name });
  const watchedValueLength =
    typeof watchedValue === 'string' ? watchedValue.length : 0;

  const charsLeft = makeCharLeftWarning(props.maxLength, watchedValueLength);
  const { errors, isDirty, isValid, isSubmitting } = useFormState();

  const hasError = !isValid && isDirty && Boolean(errors[props.name]?.message);

  return (
    <Box>
      <HookFormText {...props} disabled={isSubmitting} />
      {hasError ? null : (
        <Box margin={`-12px 0 0 0`}>
          <Text.Paragraph variant="4" subdued>
            {charsLeft}
          </Text.Paragraph>
        </Box>
      )}
    </Box>
  );
}
